import { Component } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { BaseModalComponent } from '../base-modal.component';
import { ModalType } from '../../../../js/interfaces/CoverpathTypes';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { Controller } from '../../../../../coverpath-client/public/js/Controller';

@Component({
  templateUrl: './check-legal-guardian.component.html',
})
export class CheckLegalGuardianComponent extends BaseModalComponent {
  controller: Controller;

  constructor(private amorphicService: AmorphicService, protected modalService: ModalService) {
    super(modalService);
    this.controller = this.amorphicService.controller as Controller;
  }

  ngOnInit(): void {
    this.controller.customer.application.primaryPolicy.insured.hasSigner = undefined;
  }

  cancel() {
    this.modalService.deactivate();
    this.modalService.activate({
      type: ModalType.editSignerName,
      notShowClose: true,
      disableEscapeKeyPress: true,
    });
  }

  confirm() {
    this.modalService.deactivate();
    this.modalService.activate({
      type: ModalType.confirmLegalGuardian,
      notShowClose: true,
      disableEscapeKeyPress: true,
    });
  }
}
